import React from 'react';
import styled from 'styled-components';
import { CLink, P, Text, Box, Flex } from '@appcues/component-library';
import { SUPPORT_EMAIL } from 'constants/externalAppcuesResources';

const MauMeter = props => {
  const { completePercent, currentStatus, showWarning, fillColor } = props;

  const warningText = {
    description:
      'If you exceed the MAU limit, we will reach out to you to upgrade your plan. ',
    headline: 'Approaching limit',
  };

  const overageText = {
    description:
      "You will need to upgrade your account for the next billing cycle.  We'll reach out to you with the next steps. ",
    headline: 'You have exceeded the limit',
  };

  const issueDescription =
    currentStatus === 'warning'
      ? warningText.description
      : overageText.description;

  const issueHeadline =
    currentStatus === 'warning' ? warningText.headline : overageText.headline;

  return (
    <>
      <MauMeterOuter>
        <Box
          backgroundColor={fillColor}
          width={`${completePercent}%`}
          height="100%"
        />
      </MauMeterOuter>
      {showWarning && (
        <Flex flexDirection="column" justifyContent="center">
          <P maxWidth={500}>
            <Text bold>
              🎉 {issueHeadline} - your business must be growing! &nbsp;
            </Text>
            <Text>
              {issueDescription} Questions? Email us: &nbsp;
              <CLink href={`mailto:${SUPPORT_EMAIL}`} isExternal>
                {SUPPORT_EMAIL}
              </CLink>
            </Text>
          </P>
        </Flex>
      )}
    </>
  );
};

export default MauMeter;

const MauMeterOuter = styled.div`
  background-color: ${props => props.theme['$gray-3']};
  border-radius: 100px;
  height: 8px;
  overflow: hidden;
  max-width: 500px;
  margin-bottom: 24px;
  margin-top: 8px;
`;
